import { useToast } from '@cad-arc';
import { useMemo } from 'react';
import { useApplicationType } from '../common/hooks/use-application-type';
import { useCurrentUser } from '../current-user/current-user';
import { electronBridge } from '../electron-bridge/electron-bridge';
import { createStreamListener, useStream } from '../socket/use-stream';

export function useRequestAssistanceListener() {
    const { isWeb } = useApplicationType();
    const toast = useToast();
    const currentUser = useCurrentUser();
    const streamListener = useMemo(() => {
        const streamListener = createStreamListener({
            streamNames: ['externalActionNotifications'],
            onMessage(message) {
                if (
                    (isWeb || electronBridge?.args['--workspace-window-type'] === 'EVENT_V2') &&
                    currentUser.userId === message.payload.createdByUserId
                ) {
                    toast({
                        status: message.payload.severity === 'DEFAULT' ? 'default' : 'error',
                        description: message.payload.message,
                    });
                }
            },
        });
        return streamListener;
    }, [currentUser.userId, toast, isWeb]);
    useStream(streamListener);
    return null;
}
